import { useTranslation } from "react-i18next";
import { BODY_SIDES, type Side } from "@heraion/shared";

import type { UiTheme } from "../theme";
import { ChipChoiceRow } from "./ChipChoiceRow";

// #75: Both · Left · Right, the side of an exercise. One row for the program
// editor (what the coach prescribes) and the logger (what the set is done
// on). «Both» is no side said: it hands back `undefined`, so the field goes.

/** «Both» first: it is what an exercise without a side reads as. */
const SIDES: readonly Side[] = ["both", ...BODY_SIDES];

/** The word for a side, from the shared `workout.side*` keys. */
export const useSideWord = (): Record<Side, string> => {
  const { t } = useTranslation();
  return {
    both: t("workout.sideBoth", { defaultValue: "Both" }),
    left: t("workout.sideLeft", { defaultValue: "Left" }),
    right: t("workout.sideRight", { defaultValue: "Right" }),
  };
};

export function SideChoiceRow({
  theme,
  side,
  onChange,
}: {
  theme: UiTheme;
  /** Absent: «Both». */
  side: Side | undefined;
  onChange: (side: Side | undefined) => void;
}) {
  const { t } = useTranslation();
  const word = useSideWord();
  const title = t("workout.side", { defaultValue: "Side" });
  return (
    <ChipChoiceRow
      theme={theme}
      choices={SIDES}
      selected={side ?? "both"}
      onSelect={(next) => onChange(next === "both" ? undefined : next)}
      label={(s) => word[s]}
      chipA11yLabel={(s) => word[s]}
      title={title}
      groupA11yLabel={title}
    />
  );
}
